import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";

/*
Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry

Description:
*/
import Immutable from 'immutable';
import { getErrorMessage } from '../../../../fields/format';
import getFieldKey from '../../../../form/get-field-key';

var validateFields = function validateFields(_ref) {
  var formId = _ref.formId,
      inputFields = _ref.inputFields,
      labels = _ref.labels;
  var fieldsRemapped = inputFields.reduce(function (fields, field) {
    return fields.set(field.fieldId, field);
  }, Immutable.Map());

  var getFieldName = function getFieldName(fieldKey) {
    return (labels.get(fieldKey) || {}).label;
  };

  var validationUpdates = inputFields.filter(function (field) {
    return field.onChangeCallback;
  }).reduce(function (updates, field) {
    var fieldId = field.fieldId,
        value = field.value,
        dataType = field.dataType;
    var defaultUpdates = {
      fieldId: fieldId,
      value: value,
      dataType: dataType
    };
    var onChangePayload = {
      updates: defaultUpdates,
      fieldId: fieldId,
      value: value,
      field: field,
      fields: fieldsRemapped
    };
    var fieldKey = getFieldKey({
      formId: formId,
      fieldId: fieldId
    });
    var fieldUpdates = (field.onChangeCallback(onChangePayload) || []).map(function (_ref2) {
      var fieldId = _ref2.fieldId,
          errorMessage = _ref2.errorMessage,
          showError = _ref2.showError;
      var result = {
        fieldKey: fieldKey,
        fieldId: fieldId,
        errorMessage: errorMessage,
        serverMessage: ''
      };

      if (typeof showError !== 'undefined') {
        result.showError = showError;
      }

      return result;
    });
    return updates.concat(fieldUpdates);
  }, []);
  var result = validationUpdates.concat(inputFields.filter(function (_ref3) {
    var onChangeCallback = _ref3.onChangeCallback;
    return !onChangeCallback;
  }).reduce(function (updates, _ref4) {
    var fieldKey = _ref4.fieldKey,
        dataType = _ref4.dataType,
        value = _ref4.value,
        required = _ref4.required,
        minLength = _ref4.minLength;
    return updates.concat([{
      fieldKey: fieldKey,
      errorMessage: getErrorMessage({
        dataType: dataType,
        value: value,
        required: required,
        minLength: minLength,
        fieldName: getFieldName(fieldKey)
      })
    }]);
  }, []));
  return result;
};

export default validateFields;